// Wire Configurator — GET /api/WireConfigurator (available options)
export const WIRE_CONFIGURATOR_OPTIONS_REQUEST = 'WIRE_CONFIGURATOR_OPTIONS_REQUEST'
export const WIRE_CONFIGURATOR_OPTIONS_SUCCESS = 'WIRE_CONFIGURATOR_OPTIONS_SUCCESS'
export const WIRE_CONFIGURATOR_OPTIONS_FAIL = 'WIRE_CONFIGURATOR_OPTIONS_FAIL'
export const WIRE_CONFIGURATOR_OPTIONS_RESET = 'WIRE_CONFIGURATOR_OPTIONS_RESET'

// Wire Configurator — POST /api/WireConfigurator (resolve PID for configured wire)
export const WIRE_CONFIGURATOR_RESOLVE_REQUEST = 'WIRE_CONFIGURATOR_RESOLVE_REQUEST'
export const WIRE_CONFIGURATOR_RESOLVE_SUCCESS = 'WIRE_CONFIGURATOR_RESOLVE_SUCCESS'
export const WIRE_CONFIGURATOR_RESOLVE_FAIL = 'WIRE_CONFIGURATOR_RESOLVE_FAIL'
